import { DialogService, GridButton } from '@eforall/dashboard';
import { DialogMode } from '@interfaces';
import { BaseEngagementService } from '../../../../../services';
import { FollowUpEditorDialog, FollowUpEditorDialogData } from '../../../../widget';


export function getButtons(pageService: BaseEngagementService, dialogService: DialogService) {
	const buttons: GridButton[] = [
		{
			iconClass: 'fa-plus',
			label: 'Add Follow-up',
			execute: async () => {
				const dialogData: FollowUpEditorDialogData = {
					mode: DialogMode.ADD,
					staffRoleId: pageService.staffRoleId()!,
					externalRoleId: pageService.externalRoleId?.(),
				};
				await dialogService.showCustom(FollowUpEditorDialog, { data: dialogData }, 650, 750);
				await pageService.areaService?.reloadData();
			}
		},
	];

	return buttons;
}